<template>
  <div>
    <div class="flex flex-col justify-between min-h-screen">
      <NavBar class="fixed w-full border-b"></NavBar>

      <div class="flex flex-col items-center mt-24">
        <h1
          class="title px-2 w-full flex justify-center pt-16 uppercase text-black font-bold 2xl:text-4xl xl:text-3xl text-3xl font-cfg leading-tight"
        >
          Submission Successful!
        </h1>
        <p class="text py-4">
          Check {{ this.$store.getters["emailAddress"] || "your email" }} for T
          Cell Subtype Profiling results
        </p>
        <p class="text">
          Have questions?
          <a
            href="https://www.cofactorgenomics.com/contact"
            class="underline text-blue-500"
          >
            Ask us
          </a>
        </p>
      </div>
      <Footer class="mt-10"></Footer>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
export default {
  name: "Submission",
  components: {
    NavBar,
    Footer,
  },
};
</script>

<style scoped>
.text {
  @apply font-lato text-lg leading-normal;
}
</style>
